import React from 'react';
import { useSiteData } from 'react-static';
// template components
import AdvisorConnectCard from '@nmx/template/dist/componentLibrary/modules/AdvisorConnectCard';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import frPhotoWebp from '../../../../images/financialAdvisors/leo-tucker.webp';

export default () => {
  const { config } = useSiteData();
  return (
    <AdvisorConnectCard
      sectionId='advisor-connect-card'
      moduleName='fr-card-fafa-module'
      moduleVariation='A'
      // configs
      config={config}
      disableLazyLoad
      removeDefaultCardForLeads
      // theming
      backgroundVariant='lightB'
      themeType='lightTheme'
      // content
      defaultCardProps={{
        headingText: (<>Here to help you take the <WidowBlock>first step:</WidowBlock></>),
        imageOnTop: false,
        imageSrc: frPhotoWebp,
        imageVariant: 'round',
        text: (<>Talking about finances and planning for the future might not come naturally for you, so our licensed financial advisors are here to simplify the conversation. We&#39;ll help you look at all the pieces of your financial life, design a plan tailored to your goals, and work with you to achieve each one. Fill out the form above to get matched with the right financial advisor for you.&#42;</>),
      }}
    />
  );
};
